"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColonialEnvoys = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Turmoil_1 = require("../../turmoil/Turmoil");
const SendDelegateToArea_1 = require("../../deferredActions/SendDelegateToArea");
const constants_1 = require("../../constants");
class ColonialEnvoys extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.COLONIAL_ENVOYS,
            cost: 4,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.UNITY)),
            metadata: {
                cardNumber: 'P70',
                description: 'Requires that Unity are ruling or that you have 2 delegates there. Place 1 delegate for each colony you own. YOU MAY PLACE THEM IN DIFFERENT PARTIES.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.delegates(1).asterix().slash().colonies(1);
                }),
            },
        });
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const coloniesCount = player.getColoniesCount();
        const hasEnoughDelegates = turmoil.getDelegatesInReserve(player.id) >= coloniesCount || (turmoil.getDelegatesInReserve(player.id) >= coloniesCount - 1 && turmoil.lobby.has(player.id));
        if (!hasEnoughDelegates)
            return false;
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.UNITY)) {
            return turmoil.canPlay(player, PartyName_1.PartyName.UNITY);
        }
        return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
    }
    play(player) {
        const coloniesCount = player.getColoniesCount();
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        for (let i = 0; i < coloniesCount; i++) {
            const reserveDelegateCount = turmoil.getDelegatesInReserve(player.id);
            const source = reserveDelegateCount > 0 ? 'reserve' : 'lobby';
            player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send delegate', { source: source }));
        }
        return undefined;
    }
}
exports.ColonialEnvoys = ColonialEnvoys;
//# sourceMappingURL=ColonialEnvoys.js.map